
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    
import React, {useEffect, useRef} from 'react';
import Layout from "../../lib/layout";
import dynamic from "next/dynamic";
import useTranslation from "next-translate/useTranslation";
function HomePage({locations}) {
  console.log(locations);
  const { t, lang } = useTranslation('u')
  const Map = React.useMemo(() => {

      return dynamic(
      () => import('/lib/map'),
      {
        loading: function a() {
          return <p>{t("loading_map")}</p>;
        },
        ssr: false
      }
      )
  }, [])

  return (
    <Layout
      title={t("collectors_map")}
      description={t( "collectors_on_map")}
      image="/static/fl_def.jpg"
    >
      <Map locations={locations}/>
     </Layout>
  );
}
export default HomePage;

 async function _getStaticProps() {
  const res = await fetch(`https://back.fito.land/api/users/mapsellers/`);
  const locations = await res.json();

  return {
    props: {
      locations,
    },
    revalidate: 60,
  };
}

    export async function getStaticProps(ctx) {
        let res = _getStaticProps(ctx)
        if(typeof res.then === 'function') res = await res
        return {
          ...res,
          props: {
            ...(res.props || {}),
            ...(await __loadNamespaces({
              ...ctx,
              pathname: '/u/map',
              loaderName: 'getStaticProps',
              ...__i18nConfig,
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
            }))
          }
        }
    }
  